import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";

function ScrollToTop() {
    const pathname = useRouterState({ select: (state) => state.location.pathname });

    // biome-ignore lint/correctness/useExhaustiveDependencies: Rerun scroll every time the location changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export default ScrollToTop;
